const headers = {
  name: "Taxes",
  navigate: {
    path: [
      {
        name: "Setting",
        path: "/app/settings",
      },
      {
        name: "Taxes",
        path: "/app/settings/tax",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;